import { User } from "firebase/auth";
import { useEffect, useMemo, useState } from "react";
import { isAdmin } from "../services/authService";

export const useUserIsAdmin = (user: User | null | undefined) => {
  const [loading, setLoading] = useState(true);
  const [userIsAdmin, setUserIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      const adminStatus = await isAdmin(user);
      setUserIsAdmin(adminStatus);
      setLoading(false);
    };

    if (user) {
      checkAdminStatus();
    } else {
      setLoading(false);
    }
  }, [user]);

  return useMemo(() => {
    return {
      userIsAdmin,
      loading,
    };
  }, [userIsAdmin, loading]);
};
